import React, {Fragment, ReactNode} from "react";
import {useDispatch} from "react-redux";
import {Navigate, useLocation} from "react-router-dom";
import {useAppSelector} from "../../app/hooks";
import {setAuthResult} from "../auth/AuthSlice";
import {RejectErrorType} from "./Error";
import {errorHandlerState} from "./ErrorHandlerSlice";

interface ErrorHandlerProps {
  readonly children: ReactNode;
}

const ErrorHandler = (props: ErrorHandlerProps) => {
  const {error} = useAppSelector(errorHandlerState);
  const location = useLocation();
  const dispatch = useDispatch();

  if (error) {
    if (error.type === RejectErrorType.API) {
      if (error.code === 401) {
        dispatch(setAuthResult(null));
        return <Navigate to={"/login"} state={{from: location}} />;
      }
    }
  }

  return <Fragment>{props.children}</Fragment>;
};

export default ErrorHandler;
